var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useState } from "react";
import { Col, Row } from "react-bootstrap";
import EdButton from "@frameworks/web/components/generic/edbutton/edButton";
import EdModal from "@frameworks/web/components/generic/edModal";
import ViewSubscriptopPopup from "./ViewSubscriptopPopup";
import { addDashIfNullOrUndefined } from "@domains/utils/numberMethods";
var BrokeragePlan = function (props) {
    var _a = __read(useState(false), 2), ADBlink = _a[0], setADBlink = _a[1];
    var _b = __read(useState(), 2), brokVolPlan = _b[0], setBrokVolPlan = _b[1];
    React.useEffect(function () {
        if (props.data)
            setBrokVolPlan(props.data[0]);
    }, [props.data]);
    var BrokerageVolumeColumn = [
        {
            columnName: "Segments",
            key: "Segments",
            tdCustomFunction: function (key) {
                return addDashIfNullOrUndefined(key);
            },
        },
        {
            columnName: "Rate (%)",
            key: "Rate",
            tdCustomFunction: function (key) {
                return addDashIfNullOrUndefined(key);
            },
        },
        {
            columnName: "Min Brokerage Per share",
            key: "MinBrokeragePershare",
            tdCustomFunction: function (key) {
                return addDashIfNullOrUndefined(key);
            },
        },
        {
            columnName: "Min Brokerage Per order",
            key: "MinBrokeragePerorder",
            tdCustomFunction: function (key) {
                return addDashIfNullOrUndefined(key);
            },
        },
        {
            columnName: "Rate (%)",
            key: "RateADB",
            tdCustomFunction: function (key) {
                return addDashIfNullOrUndefined(key);
            },
        },
        {
            columnName: "Min brokerage Per order",
            key: "MinbrokeragePerorderADB",
            tdCustomFunction: function (key) {
                return addDashIfNullOrUndefined(key);
            },
        },
    ];
    var BrokerageVolumeRows = [
        {
            Segments: "Cash Intraday",
            Rate: brokVolPlan === null || brokVolPlan === void 0 ? void 0 : brokVolPlan.cashIntra_Elite_Rate,
            MinBrokeragePershare: brokVolPlan === null || brokVolPlan === void 0 ? void 0 : brokVolPlan.cashIntra_Elite_MinBrokPerShare,
            MinBrokeragePerorder: brokVolPlan === null || brokVolPlan === void 0 ? void 0 : brokVolPlan.cashIntra_Elite_MinBrokPerOrder,
            RateADB: brokVolPlan === null || brokVolPlan === void 0 ? void 0 : brokVolPlan.cashIntra_ADB_Rate,
            MinbrokeragePerorderADB: brokVolPlan === null || brokVolPlan === void 0 ? void 0 : brokVolPlan.cashIntra_ADB_MinBrokPerOrder,
        },
        {
            Segments: "Cash Delivery",
            Rate: brokVolPlan === null || brokVolPlan === void 0 ? void 0 : brokVolPlan.cashDel_Elite_Rate,
            MinBrokeragePershare: brokVolPlan === null || brokVolPlan === void 0 ? void 0 : brokVolPlan.cashDel_Elite_MinBrokPerShare,
            MinBrokeragePerorder: brokVolPlan === null || brokVolPlan === void 0 ? void 0 : brokVolPlan.cashDel_Elite_MinBrokPerOrder,
            RateADB: brokVolPlan === null || brokVolPlan === void 0 ? void 0 : brokVolPlan.cashDel_ADB_Rate,
            MinbrokeragePerorderADB: brokVolPlan === null || brokVolPlan === void 0 ? void 0 : brokVolPlan.cashDel_ADB_MinBrokPerOrder,
        },
        {
            Segments: "Future",
            Rate: brokVolPlan === null || brokVolPlan === void 0 ? void 0 : brokVolPlan.fut_Elite_Rate,
            MinBrokeragePershare: brokVolPlan === null || brokVolPlan === void 0 ? void 0 : brokVolPlan.fut_Elite_MinBrokPerShare,
            MinBrokeragePerorder: brokVolPlan === null || brokVolPlan === void 0 ? void 0 : brokVolPlan.fut_Elite_MinBrokPerOrder,
            RateADB: brokVolPlan === null || brokVolPlan === void 0 ? void 0 : brokVolPlan.fut_ADB_Rate,
            MinbrokeragePerorderADB: brokVolPlan === null || brokVolPlan === void 0 ? void 0 : brokVolPlan.fut_ADB_MinBrokPerOrder,
        },
        {
            Segments: "Option",
            Rate: brokVolPlan === null || brokVolPlan === void 0 ? void 0 : brokVolPlan.opt_Elite_Rate,
            MinBrokeragePershare: brokVolPlan === null || brokVolPlan === void 0 ? void 0 : brokVolPlan.opt_Elite_MinBrokPerShare,
            MinBrokeragePerorder: brokVolPlan === null || brokVolPlan === void 0 ? void 0 : brokVolPlan.opt_Elite_MinBrokPerOrder,
            RateADB: brokVolPlan === null || brokVolPlan === void 0 ? void 0 : brokVolPlan.opt_ADB_Rate,
            MinbrokeragePerorderADB: brokVolPlan === null || brokVolPlan === void 0 ? void 0 : brokVolPlan.opt_ADB_MinBrokPerOrder,
        },
        {
            Segments: "CDS Future",
            Rate: brokVolPlan === null || brokVolPlan === void 0 ? void 0 : brokVolPlan.cdsFut_Elite_Rate,
            MinBrokeragePershare: brokVolPlan === null || brokVolPlan === void 0 ? void 0 : brokVolPlan.cdsFut_Elite_MinBrokPerShare,
            MinBrokeragePerorder: brokVolPlan === null || brokVolPlan === void 0 ? void 0 : brokVolPlan.cdsFut_Elite_MinBrokPerOrder,
            RateADB: brokVolPlan === null || brokVolPlan === void 0 ? void 0 : brokVolPlan.cdsFut_ADB_Rate,
            MinbrokeragePerorderADB: brokVolPlan === null || brokVolPlan === void 0 ? void 0 : brokVolPlan.cdsFut_ADB_MinBrokPerOrder,
        },
        {
            Segments: "CDS Option",
            Rate: brokVolPlan === null || brokVolPlan === void 0 ? void 0 : brokVolPlan.cdsOpt_Elite_Rate,
            MinBrokeragePershare: brokVolPlan === null || brokVolPlan === void 0 ? void 0 : brokVolPlan.cdsOpt_Elite_MinBrokPerShare,
            MinBrokeragePerorder: brokVolPlan === null || brokVolPlan === void 0 ? void 0 : brokVolPlan.cdsOpt_Elite_MinBrokPerOrder,
            RateADB: brokVolPlan === null || brokVolPlan === void 0 ? void 0 : brokVolPlan.cdsOpt_ADB_Rate,
            MinbrokeragePerorderADB: brokVolPlan === null || brokVolPlan === void 0 ? void 0 : brokVolPlan.cdsOpt_ADB_MinBrokPerOrder,
        },
        {
            Segments: "Commodity Future",
            Rate: brokVolPlan === null || brokVolPlan === void 0 ? void 0 : brokVolPlan.commFut_Elite_Rate,
            MinBrokeragePershare: brokVolPlan === null || brokVolPlan === void 0 ? void 0 : brokVolPlan.commFut_Elite_MinBrokPerShare,
            MinBrokeragePerorder: brokVolPlan === null || brokVolPlan === void 0 ? void 0 : brokVolPlan.commFut_Elite_MinBrokPerOrder,
            RateADB: brokVolPlan === null || brokVolPlan === void 0 ? void 0 : brokVolPlan.commFut_ADB_Rate,
            MinbrokeragePerorderADB: brokVolPlan === null || brokVolPlan === void 0 ? void 0 : brokVolPlan.commFut_ADB_MinBrokPerOrder,
        },
        {
            Segments: "Commodity Carry Forward",
            Rate: brokVolPlan === null || brokVolPlan === void 0 ? void 0 : brokVolPlan.commCarry_Elite_Rate,
            MinBrokeragePershare: brokVolPlan === null || brokVolPlan === void 0 ? void 0 : brokVolPlan.commCarry_Elite_MinBrokPerShare,
            //harcorded this values in existing CIP as well - confirmed from Nagesh
            MinBrokeragePerorder: "NA",
            RateADB: "NA",
            MinbrokeragePerorderADB: "NA",
        },
        {
            Segments: "SLBM",
            Rate: brokVolPlan === null || brokVolPlan === void 0 ? void 0 : brokVolPlan.slbM_Elite_Rate,
            MinBrokeragePershare: brokVolPlan === null || brokVolPlan === void 0 ? void 0 : brokVolPlan.slbM_Elite_MinBrokPerShare,
            MinBrokeragePerorder: brokVolPlan === null || brokVolPlan === void 0 ? void 0 : brokVolPlan.slbM_Elite_MinBrokPerOrder,
            RateADB: brokVolPlan === null || brokVolPlan === void 0 ? void 0 : brokVolPlan.slbM_ADB_Rate,
            MinbrokeragePerorderADB: brokVolPlan === null || brokVolPlan === void 0 ? void 0 : brokVolPlan.slbM_ADB_MinBrokPerOrder,
        },
    ];
    return (React.createElement("section", { id: "brokerage-plan", className: "section-padding" },
        React.createElement(Row, { className: "relationship-head-block mx-0 px-0" },
            React.createElement("div", { className: "DMSanBold_18_700 txt_blackOne1 ps-0" }, "Brokerage Plan")),
        React.createElement(Row, null,
            React.createElement(Col, { lg: 12, className: "generic-table salestableParentClass brokragev-table" },
                React.createElement("table", { className: "salestableclass brokerage" },
                    React.createElement("thead", null,
                        React.createElement("tr", null,
                            React.createElement("th", { rowSpan: 2, className: "text-start vMid" },
                                React.createElement("div", null, "Segments")),
                            React.createElement("th", { colSpan: 3, className: "text-center below-border pt-2" },
                                React.createElement("div", null, "Elite")),
                            React.createElement("th", { colSpan: 2, className: "text-center below-border pt-2" },
                                React.createElement("div", null, "ADB"))),
                        React.createElement("tr", null,
                            React.createElement("th", null, "Rate (%)"),
                            React.createElement("th", null, "Min Brokerage Per share"),
                            " ",
                            React.createElement("th", null, "Min Brokerage Per order"),
                            React.createElement("th", null, "Rate (%)"),
                            " ",
                            React.createElement("th", null, "Min brokerage Per order"))),
                    React.createElement("tbody", null, BrokerageVolumeRows.map(function (ele, idx) {
                        return (React.createElement("tr", { key: idx },
                            React.createElement("td", null, ele.Segments),
                            React.createElement("td", null, ele.Rate),
                            React.createElement("td", null, ele.MinBrokeragePershare),
                            React.createElement("td", null, ele.MinBrokeragePerorder),
                            React.createElement("td", null, ele.RateADB),
                            React.createElement("td", null, ele.MinbrokeragePerorderADB)));
                    }))))),
        React.createElement(Row, null,
            React.createElement(Col, { lg: 12, className: "text-right mt-3 DMSanM_14_500 txt_blackOne1" },
                React.createElement(EdButton, { btnTyp: "midnight-blue-underline", value: "View Subscription / ADB Details", onClick: function () { return setADBlink(true); }, className: "subscription-btn" }))),
        React.createElement("div", { className: "modal-fullwidth" }, ADBlink && (React.createElement(EdModal, { show: ADBlink, setShow: setADBlink, showFooter: false, children: React.createElement(ViewSubscriptopPopup, { setpaymentlinkshow: setADBlink }), modalTitle: "", title: "" })))));
};
export default BrokeragePlan;
